module.exports = __webpack_public_path__ + "videos/video-aleo-web.3a9181a.mp4";